import { useEffect, useLayoutEffect, useRef, type TextareaHTMLAttributes } from "react";

export function DispatchNotesInput(props: TextareaHTMLAttributes<HTMLTextAreaElement>) {
 const input=useRef<HTMLTextAreaElement>(null);
 useLayoutEffect(()=>{
  const element=input.current;
  if(!element)return;
  element.style.height="auto";
  element.style.height=`${element.scrollHeight+2}px`;
 },[props.value]);
 useEffect(()=>{
  const element=input.current;
  if(!element || typeof ResizeObserver==='undefined')return;
  let width=element.clientWidth;
  const observer=new ResizeObserver(()=>{
   if(width===element.clientWidth)return;
   width=element.clientWidth;
   element.style.height="auto";
   element.style.height=`${element.scrollHeight+2}px`;
  });
  observer.observe(element);
  return()=>observer.disconnect();
 },[]);
 return <textarea {...props} ref={input}/>;
}
